<template>

    <!-- mobile version - vertical align -->
    <div class="width-100-p">
        <div class="mobile-steps">
            <!-- Step 1: Current -->
            <div class="mobile-step-row">
                <div class="mobile-step-icon">
                    <svg class="width-60 height-60 svg-vertical-centered">
                        <use href="@/assets/svg/newSvgIcon.svg#history_card_current"></use>
                    </svg>
                </div>
                <div class="mobile-step-content">
                    <span class="moderat-white-12 mb-1">{{ cardData.current.title }}</span>
                    <p class="moderat-white-bold-22 mb-0">{{ cardData.current.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </div>
            </div>

            <!-- Vertical line 1 -->
            <div class="mobile-vertical-line"></div>

            <!-- Step 2: Under audit -->
            <div class="mobile-step-row">
                <div class="mobile-step-icon">
                    <svg class="width-60 height-60 svg-vertical-centered">
                        <use href="@/assets/svg/newSvgIcon.svg#history_card_under_audit"></use>
                    </svg>
                </div>
                <div class="mobile-step-content">
                    <span class="moderat-white-12 mb-1">{{ cardData.under_audit.title }}</span>
                    <p class="moderat-white-bold-22 mb-0">{{ cardData.under_audit.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </div>
            </div>

            <!-- Vertical line 2 -->
            <div class="mobile-vertical-line"></div>

            <!-- Step 3: Issue requested -->
            <div class="mobile-step-row">
                <div class="mobile-step-icon">
                    <svg class="width-60 height-60 svg-vertical-centered">
                        <use href="@/assets/svg/newSvgIcon.svg#history_card_issue_requested"></use>
                    </svg>
                </div>
                <div class="mobile-step-content">
                    <span class="moderat-white-12 mb-1">{{ cardData.issue_requested.title }}</span>
                    <p class="moderat-white-bold-22 mb-0">{{ cardData.issue_requested.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
                </div>
            </div>
        </div>
    </div>
  
  
  </template>
  
  <script>
  export default {
    props: {
      mobileDataProp: {
        type: Array,
        default(rawProps) {
          return rawProps;
        },
      },
    },
    components: {
      // ShowDetail,
    },
    data() {
      return {
        show: true,
        cardData: {
          current: { title: "Current", value: 0 },
          under_audit: { title: "Under audit", value: 0 },
          issue_requested: { title: "Issue requested", value: 0 },
        },

      };
    },
    computed: {
    },
    watch: {
      mobileDataProp: {
        handler: function (newValue) {
          console.log("newValue", newValue);
          this.cardData.current.value = newValue.current;
          this.cardData.under_audit.value = newValue.under_audit;
          this.cardData.issue_requested.value = newValue.issue_requested;
        },
        deep: true,
      },
    },
    methods: {},
  };
  </script>
  
  <style scoped>
  .svg-vertical-centered {
    padding-top: 4px;
    padding-bottom: 4px;
    width: 80px;
    height: 80px;
    overflow: visible;
  }
  

  
  .custom-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
    max-width: 20%;
  }


  
  .step-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
  
  .step-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  /* Mobile Steps Styling */
  .mobile-steps {
    display: flex;
    flex-direction: column;
    gap: 0px;
    padding: 20px 0;
  }

  .mobile-step-row {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .mobile-step-icon {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mobile-step-content {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 15px;
  }

  .mobile-vertical-line {
    width: 1px;
    height: 26px;
    background-color: #78BE20;
    margin-left: 15%;
    margin-right: auto;
    margin-top: 10px;
    margin-bottom: 2px;
  }

  </style>
  